import { render, staticRenderFns } from "./PantallaEntarimado.vue?vue&type=template&id=16991bfd&scoped=true&lang=true&"
import script from "./PantallaEntarimado.vue?vue&type=script&lang=js&"
export * from "./PantallaEntarimado.vue?vue&type=script&lang=js&"
import style0 from "./PantallaEntarimado.vue?vue&type=style&index=0&id=16991bfd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16991bfd",
  null
  
)

export default component.exports